const WaitingCallout = () => {
  return (
    <div className="bg-[#F8F7F3] border-l-[3px] border-[#3B82F6] rounded-r-xl p-6 mb-10">
      <h3 className="text-[15px] font-bold text-[#1A1A1A] mb-2">
        One small ask before the call
      </h3>
      <p className="text-[15px] text-[#4A4A4A] leading-relaxed">
        Have one upcoming client trip in mind — destination, travel dates, and traveller name. We'll use it to build your first real voucher together on the call.
      </p>
    </div>
  );
};

export default WaitingCallout;
